// src/user/useBitgetData.js
import { useEffect, useState } from 'react';
import axios from 'axios';

const isLocal = window.location.hostname === 'localhost';
const baseUrl = isLocal ? 'http://localhost:5000' : 'https://www.trendscout.club';

export const useBitgetPositions = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');              // 👈 define token here
    (async () => {
      try {
        const r = await axios.get(`${baseUrl}/api/gytis/positions`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          // withCredentials: true, // use this instead of Authorization if your auth is cookie-based
        });
        setPositions(r.data || []);
      } catch (e) {
        console.error('Bitget positions fetch failed:', e?.response?.status, e?.message);
        setPositions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { positions, isLoading: loading };
};

// src/user/useBitgetData.js
export const useBitgetRealizedPnl = () => {
  const [realizedPnl, setRealizedPnl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    (async () => {
      try {
        const r = await axios.get(`${baseUrl}/api/gytis/wallet/realized-pnl?days=3`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        console.log('[Bitget][realized-pnl] raw payload:', r.data);

        // normalize: ensure array + numeric fields
        const hist = Array.isArray(r.data?.history) ? r.data.history : [];
        const normalized = hist.map(x => ({
          time: typeof x.time === 'string' ? Number(x.time) : x.time, // number
          symbol: x.symbol || x.instId || x.code || 'USDT',
          income: typeof x.income === 'string' ? Number(x.income) : x.income,
          businessType: x.businessType || x.type || '',
          raw: x.raw || x,
        }));
        const totalPnl = typeof r.data?.totalPnl === 'string'
          ? Number(r.data.totalPnl)
          : (r.data?.totalPnl ?? 0);

        const payload = { totalPnl, history: normalized };
        console.log('[Bitget][realized-pnl] normalized payload:', payload);
        setRealizedPnl(payload);
      } catch (e) {
        console.error('Bitget realized PnL fetch failed:', e?.response?.status, e?.message);
        setRealizedPnl({ totalPnl: 0, history: [] });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { realizedPnl, isLoading: loading };
};

export const useBitgetWallet = () => {
  const [wallet, setWallet] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    (async () => {
      try {
        // 1️⃣ Get Bitget wallet data
        const res = await axios.get(`${baseUrl}/api/gytis/wallet`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        // 2️⃣ Get Binance public prices for spot valuation (optional)
        const priceRes = await axios.get('https://api.binance.com/api/v3/ticker/price');
        const prices = {};
        priceRes.data.forEach(p => { prices[p.symbol] = parseFloat(p.price); });

        // 3️⃣ Fetch all bots and find the one named "BitFam"
        const botsRes = await axios.get(`${baseUrl}/api/fund-sharing/bots`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        const bitfam = (botsRes.data?.bots || []).find(
          b => b.name && b.name.toLowerCase().includes('gytisbot')
        );

        // 4️⃣ Merge data together
        setWallet({
          ...res.data,                // your original wallet object
          prices,                     // add Binance prices
          bitfamTradingAmount: bitfam?.tradingAmount || 0,  // baseline
        });
      } catch (err) {
        console.error('Bitget wallet fetch failed:', err?.response?.status, err?.message);
        setWallet(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { wallet, isLoading: loading };
};


export const useBitgetOpenOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    (async () => {
      try {
        const r = await axios.get(`${baseUrl}/api/gytis/open-orders`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setOrders(r.data || []);
      } catch (e) {
        console.error("Bitget open orders fetch failed:", e?.response?.status, e?.message);
        setOrders([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { orders, isLoading: loading };
};

export const useBitgetPositionsWithTpsl = () => {
  const [positions, setPositions] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('token');
    (async () => {
      try {
        const r = await axios.get(`${baseUrl}/api/gytis/positions-with-tpsl`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });
        setPositions(r.data || []);
      } catch (e) {
        console.error('Bitget positions-with-tpsl failed:', e?.response?.status, e?.message);
        setPositions([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);
  return { positions, isLoading: loading };
};
